import React from 'react';

import { AttrsHelper } from '../../../sb-helpers/attrs-helper';
import { Layout } from '../../layout/Layout/Layout';
import { LayoutItem } from '../../layout/Layout/LayoutItem';
import { Gutter } from '../../layout/Gutter/Gutter';
import { Icon } from '../../element/Icon/Icon';
import { Flashy } from '../../element/Flashy/Flashy';
import { useBreakpoint } from '../../../hooks/useBreakpoint';

export type SortableEmptyStateProps = {
  message?: string;
  name?: string;
};

export const SortableEmptyState = ({
  message = 'No items in the list',
  name = 'SORTABLE_EMPTY_STATE',
}: SortableEmptyStateProps) => {
  const { isSmallScreen } = useBreakpoint();
  const iconGutter = isSmallScreen ? '13px' : '7px';

  return (
    <div
      className={AttrsHelper.formatClassname('sortable-empty-placeholder')}
      data-test={name}
    >
      <Gutter vertical="8px" horizontal="16px">
        <Layout position="left middle" horizontalGutter="16px">
          <LayoutItem>
            <Gutter
              name="icon-gutter"
              horizontal={iconGutter}
              vertical={iconGutter}
            >
              <Flashy color="iconSecondary" name="empty-state-icon">
                <Layout position="middle center">
                  <Icon name="plus" />
                </Layout>
              </Flashy>
            </Gutter>
          </LayoutItem>
          <LayoutItem>
            <Flashy color="textSubtle" name="empty-state-message">
              {message}
            </Flashy>
          </LayoutItem>
        </Layout>
      </Gutter>
    </div>
  );
};
